import type { ReactElement } from 'react'
import ToggleChipGroup from '../ToggleChipGroup'
import type { ToggleChipGroupItem } from '../ToggleChipGroup'
import { NOTIFICATIONS_FILTER_LABELS, NOTIFICATIONS_TEXT } from './notificationsText'
import type { NotificationsFilter } from './notificationsText'

interface NotificationFilterChipsProps {
  value: NotificationsFilter
  onChange: (filter: NotificationsFilter) => void
  /** Total of the unfiltered feed; not shown until known. */
  allCount: number | null
  unreadCount: number
}

const FILTER_ORDER: readonly NotificationsFilter[] = ['all', 'unread', 'comments', 'payments', 'statuses']

function positiveOrUndefined(value: number | null): number | undefined {
  return value !== null && value > 0 ? value : undefined
}

/** Single-select feed filter in one horizontally scrollable row. */
export default function NotificationFilterChips({
  value,
  onChange,
  allCount,
  unreadCount
}: NotificationFilterChipsProps): ReactElement {
  const items: ToggleChipGroupItem[] = FILTER_ORDER.map((filter) => ({
    key: filter,
    label: NOTIFICATIONS_FILTER_LABELS[filter],
    selected: value === filter,
    count: filter === 'all'
      ? positiveOrUndefined(allCount)
      : filter === 'unread' ? positiveOrUndefined(unreadCount) : undefined,
    onToggle: () => onChange(filter)
  }))

  return <ToggleChipGroup items={items} preset="contrast" wrap={false} ariaLabel={NOTIFICATIONS_TEXT.filtersLabel} />
}
